import { render, staticRenderFns } from "./property-prepay.vue?vue&type=template&id=96d0d3d4&scoped=true&"
import script from "./property-prepay.vue?vue&type=script&lang=js&"
export * from "./property-prepay.vue?vue&type=script&lang=js&"
import style0 from "./property-prepay.vue?vue&type=style&index=0&id=96d0d3d4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96d0d3d4",
  null
  
)

export default component.exports